export const META = {
    index: {
        // https://www.bobvoyeur.com/
        ru: {
            title: 'Bob Voyeur из Франции, настоящие домашние порно фото и видео с 2003 года',
            description:
                'Ежедневно обновляется крупнейшим сообществом эксгибиционистов и вуайеристов во Франции. Любительское порно, раздевание на улице, нагота и секс на публике, представленные настоящими любителями.'
        },
        en: {
            title: 'The French Bob Voyeur, real homemade porn photos and videos since 2003',
            description:
                'Updated daily by the largest exhibitionist and voyeur community in France. Amateur porn, outdoor flashing, nudity and sex in public submitted by real amateurs.'
        },
        fr: {
            title: 'Bob Voyeur, vos exhibes depuis 2003. Partagez vos photos et vos vidéos',
            description:
                'Le plus grand réseau adulte et amateur français pour vous exhiber devant des voyeurs et pour mater des couples, des femmes ou des hommes en réel ou en virtuel!'
        }
    },
    //variants of index <<<
    indexPhotoFemAndCouple: {
        ru: {
            title: 'Эротические фото горячих женщин и пар эксгибиционистов. Bobvoyeur – это сексуальный сайт, раскрывающий всех любителей эксгибиционизма, а также пар, практикующих свингерство.',
            description:
                'Bob Voyeur – это крупнейший развратный сайт любителей эксгибиционистов. Здесь представлена подборка эротических фото развратных обнаженных пар, похотливых самцов и сексуальных девушек. Bobvoyeur дает возможность развратных свиданий с похотливыми парами, практикующие обмен сексуальными партнерами или обмена сексуальными фото и видео, а также здесь вы можете воплотить все свои грязные эротические фантазии. Это крупнейший и лучший сайт для любителей развратного интернета во Франции.'
        },
        en: {
            title: 'Photo and video submissions of real exhibitionist amateurs. Private nude photos, explicit porn videos of naughty girlfriends and horny house wives. Dating and swinging.',
            description:
                'Bob Voyeur is a community of exhibitionist amateurs. Submitted albums of erotic charming photos, pornographic home made videos of wicked couples, hot skilful wife and black cocks, naughty men and horny women. Sex dating, swinging and porn pictures are available for our visitors. Naked girlfriends, swingers and real house wives.'
        },
        fr: {
            title: "Photos d'exhib de femmes et de couples. Bobvoyeur, site libertin d'exhibition amateur et échangisme.",
            description:
                "Bob Voyeur est le plus grand site gratuit de contributions d'amateurs et d'amatrices. Albums photos de charme et érotiques de couple libertins, d'hommes coquins et de femmes sexy. Echange, rencontre et annonces de libertinage. Le meilleur site de l'exhibition en France."
        }
    },
    indexVideoFemAndCouple: {
        ru: {
            title: 'Лучшие подборки эротического фото и порно видео пикантных девушек и развратных парочек. Bobvoyeur это сайт любителей эксгибиционизма и страстного видео.',
            description:
                'Bob Voyeur - это крупнейший бесплатный сайт любителей эксгибиционизма. Здесь представлено откровенное видео сексуальных пар, похотливых самцов и сексуальных девушек. Bobvoyeur дает возможность развратных свиданий с похотливыми парами, практикующие обмен сексуальными партнерами или обмена сексуальными фото и видео, а также здесь вы можете воплотить все свои грязные эротические фантазии. Это крупнейший и лучший сайт для любителей развратного интернета во Франции.'
        },
        en: {
            title: 'Photo and video submissions of real exhibitionist amateurs. Private nude photos, explicit porn videos of naughty girlfriends and horny house wives. Dating and swinging.',
            description:
                'Bob Voyeur is a community of exhibitionist amateurs. Submitted albums of erotic charming photos, pornographic home made videos of wicked couples, hot skilful wife and black cocks, naughty men and horny women. Sex dating, swinging and porn pictures are available for our visitors. Naked girlfriends, swingers and real house wives.'
        },
        fr: {
            title: "Vidéos d'exhib de femmes et de couples. Bobvoyeur, site coquin d'exhibition amateur et libertinage.",
            description:
                "Bob Voyeur est le plus grand site gratuit de contributions d'amateurs et d'amatrices. Vidéos de sexe de couple libertins, d'hommes coquins et de femmes sexy. Echange, rencontre et annonces de libertinage. Le meilleur site d'exhibe et d'échangisme en France."
        }
    },
    indexPhotoAndVideoMale: {
        ru: {
            title: 'Фото и видео подборки мужчин - гетеросексуалов. Bobvoyeur – это бесплатный сайт любителей эксгибиционизма и пар, практикующих свингерство.',
            description:
                'Bob Voyeur – это крупнейший свободный сайт любителей эксгибиционизма. Качественные подборки сексуального фото бисексуалов и эротического фото гетеросексуалов. Здесь у вас имеется возможность развратных свиданий с похотливыми парами, практикующие обмен сексуальными партнерами или обмена сексуальными фото и видео, а также вы можете воплотить все свои грязные эротические фантазии. Это крупнейший и лучший сайт для любителей развратного интернета во Франции.'
        },
        en: {
            title: 'Photo and video submissions of real exhibitionist amateurs. Private nude photos, explicit porn videos of naughty girlfriends and horny house wives. Dating and swinging.',
            description:
                'Bob Voyeur is a community of exhibitionist amateurs. Submitted albums of erotic charming photos, pornographic home made videos of wicked couples, hot skilful wife and black cocks, naughty men and horny women. Sex dating, swinging and porn pictures are available for our visitors. Naked girlfriends, swingers and real house wives.'
        },
        fr: {
            title: "Photos et vidéos d'exhib d'hommes hétérosexuels. Bobvoyeur, site libertin d'exhibition amateur et échangisme.",
            description:
                "Bob Voyeur est le plus grand site gratuit de contributions d'amateurs et d'amatrices. Photos de charme et érotiques d'hommes libertins hétéro ou bi. Echange, rencontre et annonces de libertinage. Le meilleur site d'exhibe et d'échangisme en France."
        }
    },
    indexCertifiedFemAndCouple: {
        // https://bobvoyeur.com/femmes-et-couples-certifies
        ru: {
            title: 'Bobvoyeur Франция | Сотни настоящих эксгибиционистов-любителей для вуайеристов',
            description:
                'Список проверенных женщин и пар, которые по-настоящему хвастаются ноготой и делятся своими домашними фотографиями и личными видео. Их профили сертифицированы как 100% любительские!'
        },
        en: {
            title: 'Bobvoyeur France | Hundreds of real amateur exhibitionists for voyeurs',
            description:
                'List of certified couples and females who show off naked for real and share their homemade photos and personal videos. Their profiles are certified 100% amateur!'
        },
        fr: {
            title: 'Des centaines d’amateurs certifiés s’exhibent en France sur Bobvoyeur',
            description:
                'Liste des couples et des femmes certifiés qui s’exhibent en réel et partagent leurs photos et leurs vidéos personnelles. Leur profil est certifié 100% amateur !'
        }
    },
    indexBestPhotos: {
        // https://www.bobvoyeur.com/les-meilleures-photos/
        ru: {
            title: 'Лучшие домашние и откровенные сексуальные фотографии, представленные французскими любителями на Bobvoyeur',
            description:
                'ЛУЧШИЕ ИЗ любительских обнаженных фотографий, представленных настоящими эксгибиционистами: публичный секс на открытом воздухе, раздевание на улице, домашнее порно, секс с незнакомцами, загорание обнаженным!'
        },
        en: {
            title: 'Best homemade & sexually explicit photos submitted by french amateurs of Bobvoyeur',
            description:
                'The BEST OF amateur nude photos submitted by real exhibitionists: outdoor public sex, flashing outside, homemade porn, dogging with strangers, nude sunbathing !'
        },
        fr: {
            title: 'Les plus belles photos d’exhibition et de sexe amateur de Bobvoyeur !',
            description:
                'Le Best Of de vos exhibes en extérieur et de nudité en public + la sélection de vos meilleures photos de charme et de sexe ! Que du réel et de l’amateur !'
        }
    },
    // >>> variants of index

    profiles: {
        // https://www.bobvoyeur.com/profiles/
        ru: {
            title: 'Французские эксгибиционисты и вуайеристы в сообществе Bobvoyeur',
            description:
                'Свяжитесь с настоящими любителями, которые делятся своими сексуальными фотографиями и фильмами со взрослыми вуайеристами: горячими женами, сексуальными подругами, похотливыми супружескими парами, свингерами.'
        },
        en: {
            title: 'French exhibitionists & voyeurs in the amateur community of Bobvoyeur',
            description:
                'Get in touch with real amateurs who share their private sex pictures & movies with adult voyeurs: hot wives, sexy girlfriends, horny married couples, swingers.'
        },
        fr: {
            title: 'Les membres exhibitionnistes et voyeurs de la communauté Bobvoyeur',
            description:
                'Trouvez de vrais amateurs proches de vous parmi les milliers de membres de la communauté EXHIBE | VOYEUR de Bobvoyeur. Découvrez leurs profils et prenez contact'
        }
    },
    searchTags: {
        ru: {
            title: 'Поиск по ключевым словам любительских обнаженных фото и порно видео на Bobvoyeur',
            description:
                'Используйте этот инструмент поиска, чтобы просмотреть весь любительский контент, опубликованный на Bob Voyeur с 2003 года тысячами взрослых эксгибиционистов и вуайеристов.'
        },
        en: {
            title: 'Search by tags for amateur nude photos and porn videos on Bobvoyeur.',
            description:
                'Use this search tool to view all the sexually explicit and home made content submitted to Bob Voyeur since 2003 by thousands of adult exhibitionists and voyeurs.'
        },
        fr: {
            title: 'Cherchez par mots clés des photos et des vidéos d’exhibe sur Bobvoyeur',
            description:
                'Utilisez cet outil de recherche pour visionner tout le contenu amateur publié sur Bob Voyeur depuis 2003 par des milliers d’adultes exhibitionnistes et voyeurs.'
        }
    },
    searchTagsPhoto: {
        ru: {
            title: 'Поиск по ключевым словам любительских обнаженных фото на Bobvoyeur',
            description:
                'Используйте этот инструмент поиска, чтобы просмотреть весь любительский контент, опубликованный на Bob Voyeur с 2003 года тысячами взрослых эксгибиционистов и вуайеристов.'
        },
        en: {
            title: 'Search by tags for amateur photos submitted on Bobvoyeur',
            description:
                'Use this search tool to view nude flashing pictures posted on Bob Voyeur since 2003 by thousands of exhibitionist couples, horny wives, hot swingers, horny men…'
        },
        fr: {
            title: 'Cherchez par mots clés des photos d’exhibe sur Bobvoyeur',
            description:
                'Utilisez cet outil de recherche pour visionner les photos d’exhibe publiées sur Bob Voyeur depuis 2003 par des milliers d’amateurs exhibitionnistes et voyeurs'
        }
    },
    searchTagsVideo: {
        ru: {
            title: 'Поиск по ключевым словам любительских обнаженных порно видео на Bobvoyeur',
            description:
                'Используйте этот инструмент поиска, чтобы просмотреть весь любительский контент, опубликованный на Bob Voyeur с 2003 года тысячами взрослых эксгибиционистов и вуайеристов.'
        },
        en: {
            title: 'Search by tags for XXX home video clips submitted on Bobvoyeur',
            description:
                'Use this search tool to view homemade movies posted on Bob Voyeur since 2003 by amateurs who dare to show themselves naked outdoor, nude wives teasing strangers in public…'
        },
        fr: {
            title: 'Cherchez par mots clés des vidéos d’exhibe sur Bobvoyeur',
            description:
                'Utilisez cet outil de recherche pour visionner les vidéos d’exhibe publiées sur Bob Voyeur depuis 2003 par des milliers d’amateurs exhibitionnistes et voyeurs'
        }
    },
    searchTagsResults: {
        ru: {
            title: '{TAG} | фото и видео любителей на Bobvoyeur',
            description:
                'Тысячи бесплатных любительских фотографий и видео | {TAG} | для просмотра на Bob Voyeur из Франции'
        },
        en: {
            title: '{TAG} | pictures and movies from real amateurs on Bobvoyeur',
            description: 'Thousands of homemade photos and amateur porn videos | {TAG} | to watch on Bob Voyeur France'
        },
        fr: {
            title: '{TAG} | photos et vidéos des amateurs de Bobvoyeur',
            description: 'Des milliers de photos et de vidéos gratuites | {TAG} | à découvrir sur Bob Voyeur France'
        }
    },
    searchTagsResultsPhoto: {
        ru: {
            title: '{TAG} | Домашние фотографии на Bob Voyeur',
            description:
                'Тысячи любительских фото | {TAG} | Каждый день люди делятся обнаженными фотографиями на Bobvoyeur Франция'
        },
        en: {
            title: '{TAG} | Real amateur photos from Bob Voyeur',
            description:
                'Thousands of amateur exhibitionists pictures | {TAG} | Real people dare to show their nude photos on Bobvoyeur France'
        },
        fr: {
            title: '{TAG} | les photos des amateurs de Bob Voyeur',
            description: 'Des milliers de photos gratuites | {TAG} | à découvrir sur Bobvoyeur France'
        }
    },
    searchTagsResultsVideo: {
        ru: {
            title: '{TAG} | Домашнее видео на Bob Voyeur',
            description:
                'Тысячи любительских видео | {TAG} | Каждый день люди делятся обнаженными видео на Bobvoyeur Франция'
        },
        en: {
            title: '{TAG} | Homemade videos from Bob Voyeur',
            description:
                'Thousands of amateur exhibitionists videos | {TAG} | Everyday people dare to show themselves naked on Bobvoyeur France'
        },
        fr: {
            title: '{TAG} | les vidéos des amateurs de Bob Voyeur',
            description: 'Des milliers de vidéos gratuites | {TAG} | à découvrir sur Bobvoyeur France'
        }
    },
    searchContributions: {
        ru: {
            title: 'Поиск порно по ключевому слову среди материалов для взрослых на Bobvoyeur',
            description:
                'Используйте этот инструмент поиска, чтобы просмотреть все материалы об эксбиционизме, опубликованные на Bobvoyeur с 2003 года эксгибиционистами и свингерами.'
        },
        en: {
            title: 'Search by category for porn submitted by real amateurs on Bobvoyeur',
            description:
                'Use this search tool to sort through the sex and nudity contributions submitted to Bobvoyeur since 2003 by thousands of amateur exhibitionists and swingers.'
        },
        fr: {
            title: 'Cherchez par mots clés parmi les contributions d’adultes sur Bobvoyeur',
            description:
                ' Utilisez cet outil de recherche pour visionner toutes les contributions d’exhibe publiées sur Bobvoyeur depuis 2003 par des amateurs exhibitionnistes et réels.'
        }
    },
    searchContributionsPhoto: {
        ru: {
            title: 'Поиск порно по ключевому слову среди подборок фотографий для взрослых на Bob Voyeur',
            description:
                'Используйте этот инструмент поиска, чтобы просмотреть все подборки фотографий об эксбиционизме, опубликованные на Bobvoyeur с 2003 года эксгибиционистами и свингерами.'
        },
        en: {
            title: "Search Bob Voyeur's photo submissions, sexually explicit content by tags",
            description:
                "Use this search engine to find contributions from amateurs of Bobvoyeur's exhibitionist community. Flashing outside, teasing on the nudist beach, homemade porn"
        },
        fr: {
            title: 'Triez par mots clés les contributions photos de Bob Voyeur',
            description:
                'Utilisez cet outil de recherche pour mater toutes les contributions photos publiées sur Bobvoyeur par des exhibitionnistes amateurs depuis 2003'
        }
    },
    searchContributionsVideo: {
        ru: {
            title: 'Поиск порно по ключевому слову среди подборок для взрослых на Bobvoyeur',
            description:
                'Используйте этот инструмент поиска, чтобы просмотреть все подборки с видео об эксбиционизме, опубликованные на Bob Voyeur с 2003 года эксгибиционистами и свингерами.'
        },
        en: {
            title: 'Use this search engine to view Bobvoyeur’s erotic video contributions',
            description:
                'Use the search engine to view movie submissions published on Bob Voyeur since 2003 by amateurs who dare to show themselves naked, fuck in public or on beach.'
        },
        fr: {
            title: 'Triez par mots clés les contributions vidéos de Bobvoyeur',
            description:
                'Utilisez cet outil de recherche pour mater toutes les contributions vidéos publiées sur Bob Voyeur par des exhibitionnistes amateurs depuis 2003'
        }
    },
    searchContributionsResults: {
        ru: {
            title: '{TAG} | любительские подборки Bob Voyeur',
            description: 'Тысячи бесплатных подборок | {TAG} | для просмотра на французском Bobvoyeur'
        },
        en: {
            title: '{TAG} | Amateur submissions from Bob Voyeur',
            description:
                'Thousands of contributions | {TAG} | to discover on Bobvoyeur France - homemade nude photos and explicit videos by real people who dare to get naked.'
        },
        fr: {
            title: '{TAG} | les contributions amateurs de Bob Voyeur',
            description: 'Des milliers de contributions gratuites | {TAG} | à découvrir sur Bobvoyeur France'
        }
    },
    searchContributionsResultsPhoto: {
        ru: {
            title: '{TAG} | любительские фотографии Bobvoyeur',
            description: 'Тысячи бесплатных фотографий | {TAG} | для просмотра на французском Bobvoyeur'
        },
        en: {
            title: '{TAG} | Real amateur contributions from Bob Voyeur',
            description:
                'Thousands of nude and pornographic amateur photos | {TAG} | Real people dare to show off naked on Bobvoyeur France'
        },
        fr: {
            title: '{TAG} | les contributions photos de Bobvoyeur',
            description: 'Des milliers de contributions photos | {TAG} | à découvrir sur Bobvoyeur'
        }
    },
    searchContributionsResultsVideo: {
        ru: {
            title: '{TAG} | любительские видео Bob voyeur',
            description: 'Тысячи бесплатных видео | {TAG} | для просмотра на французском Bobvoyeur'
        },
        en: {
            title: '{TAG} | amateur-submitted videos from Bob Voyeur',
            description:
                'Video contributions submitted by amateurs on Bobvoyeur |{TAG} | 100% homemade sexually explicit content'
        },
        fr: {
            title: '{TAG} | les contributions vidéos de Bob Voyeur',
            description: 'Des milliers de contributions vidéos | {TAG} | à découvrir sur Bobvoyeur'
        }
    },
    paginationTags: {
        ru: {
            title: 'Категории фото и видео эксгибиционистов-любителей на Bobvoyeur',
            description:
                'Все фото и видео эксгибиционистов, эротические и секс-фото и видео, классифицированные по ключевым словам на Bob Voyeur Франция - заигрывание, порно, раздевание на публике или приватно.'
        },
        en: {
            title: 'Tags for photos & videos submitted to Bobvoyeur, Erotic and Porn',
            description:
                'Browse all nude photos and homemade videos sorted by category on Bob Voyeur France (nude beach, dogging, outdoor public sex, flashing, upskirt, wife teasing...)'
        },
        fr: {
            title: 'Catégories des photos et des vidéos d’exhibes amateurs de Bobvoyeur',
            description:
                'Toutes les photos et les vidéos d’exhibition, érotiques et de sexe classées par mot clés sur Bob Voyeur France - charme, porno, exhibe en public ou en privé.'
        }
    },
    paginationSearch: {
        ru: {
            title: 'Популярные запросы на Bobvoyeur | Домашние фото и откровенные видео |',
            description:
                'Самые популярные любительские фото- и видеоконтент на Bob Voyeur France - эксбиционизм на открытом воздухе, приватный и публичный секс, эротика и порнография'
        },
        en: {
            title: 'Popular searches on Bobvoyeur, Homemade pictures and explicit movies',
            description:
                'Most searched sexually explicit content on Bob Voyeur France. (public nudity, group sex, dogging, wife flashing outside, voyeur beach, swinger, upskirting...)'
        },
        fr: {
            title: 'Les recherches populaires sur Bobvoyeur | Photos et Vidéos d’exhib',
            description:
                'Contenu amateur photo et vidéo le plus recherché sur Bob Voyeur France - exhibe en extérieur, sexe en privé et en public, érotisme et pornographie'
        }
    },
    contact: {
        ru: {
            title: 'Контакты и техническая поддержка | Bob Voyeur, французское сообщество эксгибиционистов',
            description:
                'Онлайн-помощь и техническая поддержка Bobvoyeur, отправляйте свои запросы и вопросы о веб-сайте, вашей регистрации, вашем аккаунте или вашей подписке.'
        },
        en: {
            title: 'Contact and Support | Bob Voyeur, the French exhibitionist community',
            description:
                'Bobvoyeur online help and support, send your requests and questions about the website, your registration, your user account or your subscription.'
        },
        fr: {
            title: 'Contact et Support Technique | Bob Voyeur France, l’exhibe d’amateurs',
            description:
                'Aide et support en ligne de Bobvoyeur, adressez vos demandes et vos questions concernant le site, votre enregistrement, votre compte d’utilisateur et votre abonnement.'
        }
    },
    geo: {
        ru: {
            title: 'Знакомства с эксбиционистами и вуайеристами по геолокации на Bob Voyeur Франция',
            description:
                'Найдите вуайеристов и эксгибиционистов рядом с вами, увеличьте масштаб карты, чтобы увидеть и познакомиться с реальными людьми в вашем районе и рядом с вами.'
        },
        en: {
            title: 'Dating exhibitionists and voyeurs by geolocation on Bob Voyeur France',
            description:
                'Locate voyeurs, swingers & exhibitionists around you, zoom the map for outdoor flashing or dogging in your area. Meet at a naturist beach, in a bar or in a public place.'
        },
        fr: {
            title: 'Rencontres EXHIBE | VOYEUR par géolocalisation sur Bob Voyeur France',
            description:
                'Localisez les voyeurs et les exhibitionnistes autour de vous, zoomez la carte pour mater et faire des rencontres réelles dans votre région et près de chez vous'
        }
    },
    payment: {
        ru: {
            title: 'Защищенная страница оплаты - Bobvoyeur',
            description: ''
        },
        en: {
            title: 'Secure payment page - Bobvoyeur',
            description: ''
        },
        fr: {
            title: 'Page de paiement sécurisée - Bobvoyeur',
            description: ''
        }
    },
    member: {
        ru: {
            title: 'Мой профиль - Bobvoyeur',
            description: ''
        },
        en: {
            title: 'My Bobvoyeur Profile',
            description: ''
        },
        fr: {
            title: 'Mon Profil Bobvoyeur',
            description: ''
        }
    },
    profile: {
        ru: {
            title: '{NICK} ({GENDER}) демонстрирует себя на Bobvoyeur | {LOCATION} |',
            description:
                '{NICK} ({GENDER}) из | {LOCATION} | участвует в Bobvoyeur, крупнейшей сети эксгибиционистов и вуайеристов с 2003 года.'
        },
        en: {
            title: '{NICK} ({GENDER}) shows off naked on Bobvoyeur | {LOCATION} |',
            description:
                '{NICK} ({GENDER}) from | {LOCATION} | is showing off naked on Bob Voyeur, the French exhibitionnist network'
        },
        fr: {
            title: '{NICK} ({GENDER}) s’exhibe sur Bobvoyeur | {LOCATION} |',
            description: '{NICK} est sur Bobvoyeur, le plus grand réseau EXHIBE | VOYEUR depuis 2003.'
        }
    },
    notifications: {
        ru: {
            title: 'Мои уведомления на Bobvoyeur',
            description: ''
        },
        en: {
            title: 'My Bobvoyeur notifications',
            description: ''
        },
        fr: {
            title: 'Mes notifications sur Bobvoyeur',
            description: ''
        }
    },
    notificationsSettings: {
        ru: {
            title: 'Мои настройки уведомлений',
            description: ''
        },
        en: {
            title: 'My notifications settings',
            description: ''
        },
        fr: {
            title: 'Mes paramètres de notifications',
            description: ''
        }
    },
    myGuestbook: {
        ru: {
            title: 'Моя гостевая книга',
            description: ''
        },
        en: {
            title: 'My Bobvoyeur Guest Book',
            description: ''
        },
        fr: {
            title: "Mon livre d'or sur Bobvoyeur",
            description: ''
        }
    },
    userGuestbook: {
        ru: {
            title: 'Гостевая книга пользователя {NICK} на Bob Voyeur France',
            description:
                'Прочтите отзывы, написанные пользователю {NICK} из {LOCATION} сообществом EXHIBE | VOYEUR от Bobvoyeur'
        },
        en: {
            title: 'The guestbook of {NICK} who shows off nude on Bob Voyeur',
            description:
                "Read the encouragement sent to {NICK} from {LOCATION} by Bobvoyeur's exhibitionist community for posting private nude photos and homemade sex videos"
        },
        fr: {
            title: 'Le livre d’or de {NICK} qui s’exhibe sur Bob Voyeur',
            description:
                'Lisez les encouragements envoyés à {NICK} de {LOCATION} par la communauté amateur de Bobvoyeur pour ses photos d’exhibe à poil et ses vidéos de sexe'
        }
    },
    blacklist: {
        ru: {
            title: 'Мой черный список на Bobvoyeur',
            description: ''
        },
        en: {
            title: 'My Bobvoyeur blacklist',
            description: ''
        },
        fr: {
            title: 'Ma black liste sur Bobvoyeur',
            description: ''
        }
    },
    following: {
        ru: {
            title: 'Мои подписки на Bobvoyeur',
            description: ''
        },
        en: {
            title: 'My Bobvoyeur followees',
            description: ''
        },
        fr: {
            title: 'Mes abonnements sur Bobvoyeur',
            description: ''
        }
    },
    myFollowers: {
        ru: {
            title: 'Мои подписчики на Bobvoyeur',
            description: ''
        },
        en: {
            title: 'My Bobvoyeur followers',
            description: ''
        },
        fr: {
            title: 'Mes abonnés sur Bobvoyeur',
            description: ''
        }
    },
    userFollowers: {
        ru: {
            title: 'Подписчики пользователя {NICK} на Bobvoyeur, сообществе эксгибиционистов и вуайеристов',
            description:
                'Пользователи, которые следят за {NICK} на Bobvoyeur. Обмен личными фотографиями и видео, приватный чат, обнажение с веб-камерой, раздевание на улице и публичный секс'
        },
        en: {
            title: "{NICK}'s followers, exhibitionist & voyeur community",
            description:
                'Members who follow {NICK} on Bobvoyeur. Sharing personal photos & videos, private chatting, showing off nude on webcam, outdoor flashing and public sex'
        },
        fr: {
            title: 'Les abonnés de {NICK} sur Bobvoyeur, communauté exhibitioniste et voyeur',
            description:
                'Les membres qui suivent {NICK} sur Bobvoyeur. Partage de photos et de vidéos personnelles, discussions privées, exhibes virtuelle (tchat webcam) et réelle'
        }
    },
    favoriteContributions: {
        ru: {
            title: 'Мои избранные подборки на Bobvoyeur',
            description: ''
        },
        en: {
            title: 'My favourite Bobvoyeur contributions',
            description: ''
        },
        fr: {
            title: 'Mes contributions favorites sur Bobvoyeur',
            description: ''
        }
    },
    favoriteContributors: {
        ru: {
            title: 'Мои избранные участники на Bobvoyeur',
            description: ''
        },
        en: {
            title: 'My favourite Bobvoyeur contributors',
            description: ''
        },
        fr: {
            title: 'Mes contributeurs favoris sur Bobvoyeur',
            description: ''
        }
    },
    premiumHistory: {
        ru: {
            title: 'История моих покупок Premium на Bobvoyeur',
            description: ''
        },
        en: {
            title: 'My Premium membership history on Bobvoyeur',
            description: ''
        },
        fr: {
            title: 'Historique de mes abonnements Premium sur Bobvoyeur',
            description: ''
        }
    },
    myAlbums: {
        ru: {
            title: 'Мои альбомы на Bobvoyeur',
            description: ''
        },
        en: {
            title: 'My photo albums on Bobvoyeur',
            description: ''
        },
        fr: {
            title: 'Mes albums photos sur Bobvoyeur',
            description: ''
        }
    },
    myContributions: {
        ru: {
            title: 'Мои подборки на Bobvoyeur',
            description: ''
        },
        en: {
            title: 'My contributions on Bobvoyeur',
            description: ''
        },
        fr: {
            title: 'Mes contributions sur Bobvoyeur',
            description: ''
        }
    },
    userAlbums: {
        ru: {
            title: 'Фотоальбомы пользователя {NICK} на Bob Voyeur | {LOCATION} |',
            description:
                '{NICK} раздевается в реальности ({LOCATION}) и виртуально на Bobvoyeur, загляните в его профиль!'
        },
        en: {
            title: "{NICK}'s photo album on Bob Voyeur | {LOCATION} |",
            description:
                '{NICK} shows off naked on Bobvoyeur. Amateur erotic and pornographic photos & videos from {LOCATION}'
        },
        fr: {
            title: 'L’album photo de {NICK} sur Bob Voyeur | {LOCATION} |',
            description: '{NICK} s’exhibe en réel ({LOCATION}) et en virtuel sur Bobvoyeur, venez mater son profil !'
        }
    },
    userContributions: {
        ru: {
            title: 'Откровенные подборки {NICK} на Bobvoyeur',
            description: '{NICK} публикует фото и видео, чтобы похвастаться на Bob Voyeur ({LOCATION})'
        },
        en: {
            title: "{NICK}'s submissions on Bobvoyeur",
            description: '{NICK} posts nude photos and explicit videos to show off on Bob Voyeur ({LOCATION})'
        },
        fr: {
            title: 'Les contributions d’exhibe de {NICK} sur Bobvoyeur',
            description: '{NICK} poste des contributions photos et vidéos pour s’exhiber sur Bob Voyeur ({LOCATION})'
        }
    },
    stub: {
        ru: {
            title: 'Для доступа к этой странице требуется авторизация',
            description: ''
        },
        en: {
            title: 'Authorisation required to access this page',
            description: ''
        },
        fr: {
            title: 'Autorisation requise pour accèder à cette page.',
            description: ''
        }
    },
    cgu: {
        ru: {
            title: 'Общие условия использования сайтов Боба',
            description: 'Прочтите правила, условия использования и юридическую информацию Bobvoyeur, BobTV и Bob4men.'
        },
        en: {
            title: 'Terms and Conditions of Use of BOB websites',
            description: 'Read the terms, conditions of use and legal information about Bobvoyeur, BobTV and Bob4men.'
        },
        fr: {
            title: 'Les conditions générales d’utilisation des sites de Bob',
            description:
                'Lisez le règlement, les conditions d’utilisation et les informations légales de Bobvoyeur, BobTV et Bob4men.'
        }
    },
    pmConversations: {
        ru: {
            title: 'Мои личные сообщения',
            description: ''
        },
        en: {
            title: 'My private messages',
            description: ''
        },
        fr: {
            title: 'Mes messages privés',
            description: ''
        }
    },
    pmRequests: {
        ru: {
            title: 'Мои запросы на личные сообщения',
            description: ''
        },
        en: {
            title: 'My private message requests',
            description: ''
        },
        fr: {
            title: 'Mes demandes de messages privés',
            description: ''
        }
    },
    myWallet: {
        ru: {
            title: 'Мой виртуальный кошелёк',
            description: ''
        },
        en: {
            title: 'My virtual wallet',
            description: ''
        },
        fr: {
            title: 'Mon porte monnaie virtue',
            description: ''
        }
    },
    myVirtualGifts: {
        ru: {
            title: 'Мои виртуальные подарки на Bobvoyeur',
            description: ''
        },
        en: {
            title: 'My Bobvoyeur virtual gifts',
            description: ''
        },
        fr: {
            title: 'Mes cadeaux virtuels sur Bobvoyeur',
            description: ''
        }
    },
    userVirtualGifts: {
        ru: {
            title: 'Виртуальные подарки пользователя ',
            description: ''
        },
        en: {
            title: 'Virtual gifts of ',
            description: ''
        },
        fr: {
            title: 'Les cadeaux virtuels de ',
            description: ''
        }
    },
    giftsCatalog: {
        ru: {
            title: 'Отправьте подарок пользователю {NICK}, который демонстрирует себя на Bobvoyeur.',
            description: 'Сделать подарок пользователю {NICK}, который раздевается онлайн на Bobvoyeur в реальной жизни'
        },
        en: {
            title: 'Give a gift to {NICK} who shows off on BobVoyeur',
            description:
                'Make {NICK} from {LOCATION} happy. A proud member of our french adult community (exhibitionists, voyeurs and swingers)'
        },
        fr: {
            title: 'Offrez un cadeau à {NICK} qui s’exhibe sur BobVoyeur',
            description: 'Faites plaisir à {NICK} qui s’exhibe en ligne sur Bobvoyeur et en réel ({LOCATION})'
        }
    },
    posts: {
        ru: {
            title: 'Сообщения {NICK} на форуме BobVoyeur',
            description:
                'Прочтите сообщения {NICK} на форуме Bobvoyeur. Переписка о любительском эксгибиционизме, вуайеризме и распутстве ({LOCATION}).'
        },
        en: {
            title: "{NICK}'s posts on the Bob Voyeur FORUM",
            description:
                "Read {NICK}'s topics and replies on Bobvoyeur’s forum. Discussion thread on exhibitionism, voyeurism, swinging lifestyle and sexual practices."
        },
        fr: {
            title: 'Les posts de {NICK} sur le FORUM de Bobvoyeur',
            description:
                'Lisez les participations de {NICK} sur le forum de Bobvoyeur. Conversations sur l’exhibition amateur, le voyeurisme et le libertinage ({LOCATION}).'
        }
    },
    defaultUserMaterial: {
        ru: {
            description:
                'Личные фотографии или видео, опубликованные пользователем {NICK} ({LOCATION}), демонстрирующие обнаженное тело Боба Вуайериста. {NICK} — любитель, этот контент защищен правами на изображение.'
        },
        en: {
            description:
                'Personal photo or video posted by {NICK} ({LOCATION}) showing off nude on Bob Voyeur. {NICK} is an amateur, this content is protected by image rights.'
        },
        fr: {
            description:
                'Photo ou vidéo personnelle postée par {NICK} ({LOCATION}) qui s’exhibe sur Bob Voyeur. {NICK} est amateur, ce contenu est protégé par le droit à l’image.'
        }
    },
    defaultUserContribution: {
        ru: {
            description:
                'Любительские фотографии и видео, опубликованные пользователем {NICK} в Bobvoyeur, сообществе французских эксгибиционистов и вуайеристов.'
        },
        en: {
            description:
                'Amateur Photos and Videos posted by {NICK} on Bobvoyeur, the French Exhibitionist and Voyeur Community.'
        },
        fr: {
            description:
                'Photos et vidéos amateurs publiées par {NICK} sur Bobvoyeur la communauté Exhibe et Voyeur française.'
        }
    },
    archive: {
        ru: {
            title: 'Архив Боба Вуайера, {MONTH} {YEAR}. {CONTRIBUTIONS} - это количетсво подборок содержащие фотографии и видео эксгибиционистов-любителей.',
            description:
                'Фото и видео любительских выставок месяца за {MONTH} {YEAR} на Bobvoyeur. Все материалы предоставлены сообществом распутников Боба Вуайериста.'
        },
        en: {
            title: 'Archive of Bob Voyeur, {MONTH} {YEAR}. {CONTRIBUTIONS} contributions photos and videos of amateur exhibitionists.',
            description:
                "Photos and videos of amateur exhibitions of the month from {MONTH} {YEAR} on Bobvoyeur. All exhibition contributions from Bob the Voyeur's libertine community."
        },
        fr: {
            title: "Archive de Bob Voyeur, {MONTH} {YEAR}. {CONTRIBUTIONS} contributions photos et vidéos d'exhib amateur.",
            description:
                "Les photos et les vidéos d'exhibition d'amateurs du mois de {MONTH} {YEAR} sur Bobvoyeur. Toutes les contributions d'exhibes de la communauté libertine de Bob le Voyeur."
        }
    },
    ephemeral: {
        ru: {
            title: '🔥 Временные фото для взрослых | Исчезают через 24 часа',
            description:
                'Эксклюзивные фото для взрослых, которые автоматически удаляются через 24 часа. Только приватный доступ – наслаждайтесь без следа. 18+'
        },
        en: {
            title: '🔥 24-Hour Disappearing Adult Photos | Private & Secure',
            description:
                'Exclusive adult content that disappears after 24 hours. Enjoy private adult photos with no traces left. 18+ only.'
        },
        fr: {
            title: '🔥 Vos Photos Adultes Éphémères | Disparaissent en 24h',
            description:
                "Votre contenu adulte exclusif s'efface automatiquement après 24h. Accès privé et sécurisé. 18+"
        }
    },
    empty: {
        ru: {
            title: '',
            description: ''
        },
        en: {
            title: '',
            description: ''
        },
        fr: {
            title: '',
            description: ''
        }
    }
}
